<app-insights-header mrt-insights-header [mobileFilterBreakpointReached]='mobileFilterBreakpointReached'
  [isFollowing]='isFollowing' [processingFollow]='isProcessing' [followBreakpointReached]='followBreakpointReached'
  (mobileNavOpenClick)='showMobileNav = !showMobileNav' (followButtonClick)='handleFollowClick($event)'
  (applyFilter)="applyFilter()" (resetFilter)="resetFilter()" (showFilter)="showFilter()">
  <div class="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups" mrt-insights-filters>
    <ng-container *ngIf="osOptions?.length > 0">
      <div class="btn-group toggle-filter insight-toggle-filter" role="group" aria-label="Basic example">
        <button [hidden]="option.hidden" type="button" class="btn btn-secondary" *ngFor="let option of osOptions"
          [ngClass]="{ 'active': option.active }" (click)="changeDevice(option.value)" [innerHTML]="option.text">
        </button>
      </div>
    </ng-container>

    <ng-container *ngIf="desktop$ | async">
      <ng-container *ngFor="let mainFilterItem of mainFilterItems; let i=index;">
        <div class="dropdown filter-dropdown ml-2" [ngClass]="{ 'disabled' : mainFilterItem?.disabled }">
          <button class="btn btn-secondary dropdown-toggle" type="button" [attr.id]="'dropdownMenuButton-'+i"
            [ngClass]="{highlighted : mainFilterItem?.highlighted, 'disabled' : mainFilterItem?.disabled}"
            data-toggle="dropdown" aria-haspopup="true"
            (click)="selectedMainFilterItemClick(mainFilterItem, $event, true)" aria-expanded="false"
            [innerHTML]="mainFilterItem?.selected?.label">
          </button>
          <div class="filter-dropdown-tooltip"
            *ngIf="mainFilterItem?.showTooltip && mainFilterItem?.tooltip?.length > 0">
            {{mainFilterItem?.tooltip}}
            <i class="fa fa-caret-down"></i>
          </div>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <ng-container *ngIf="mainFilterItem?.options?.length > 10">
              <div class="input-group">
                <span class="input-group-addon" id="search-country">
                  <i class="fa fa-search"></i>
                </span>
                <input type="text" class="form-control" placeholder="Search..."
                  [attr.id]="'search-input-' + mainFilterItem?.key"
                  [attr.aria-describedby]="'search-country-'+mainFilterItem?.key"
                  (keydown.enter)="searchMainFilterItemOption(mainFilterItem, $event)">
              </div>
            </ng-container>
            <div class="dropdown-menu-items">
              <ng-container *ngFor="let option of mainFilterItem?.options">
                <ng-container *ngIf="!option?.hidden">
                  <a class="dropdown-item" (click)="selectMainFilter(mainFilterItem,option)" [innerHTML]="option.label">
                  </a>
                </ng-container>
              </ng-container>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="tablet$ | async">
      <ng-container *ngFor="let mainFilterItem of mainFilterItems; let i=index;">
        <div class="mobile-filter dropdown filter-dropdown ml-2" [ngClass]="{ 'disabled' : mainFilterItem?.disabled }">
          <button class="btn btn-secondary dropdown-toggle" type="button" [attr.id]="'dropdownMenuButton-'+i"
            [ngClass]="{highlighted : mainFilterItem?.highlighted, 'disabled' : mainFilterItem?.disabled}"
            data-toggle="dropdown" aria-haspopup="true"
            (click)="selectedMainFilterItemClick(mainFilterItem, $event, true)" aria-expanded="false"
            [innerHTML]="mainFilterItem?.selected?.label">
          </button>
          <div class="filter-dropdown-tooltip"
            *ngIf="mainFilterItem?.showTooltip && mainFilterItem?.tooltip?.length > 0">
            {{mainFilterItem?.tooltip}}
            <i class="fa fa-caret-down"></i>
          </div>
          <hr />
          <div class="options-overlay" [ngClass]="{'show': mainFilterItem.show}" aria-labelledby="dropdownMenuButton"
            (click)="toggleDropdownOption(mainFilterItem, false)">
            <div class="options-container">
              <span class="h5 m-3 text-capitalize">{{ mainFilterItem.key }}</span>
              <hr />
              <ng-container *ngFor="let option of mainFilterItem?.options">
                <div class="d-flex flex-row justify-content-between m-3">
                  <a (click)="selectMainFilter(mainFilterItem,option,false)" [innerHTML]="option?.label"
                    [hidden]="option?.hidden">
                  </a>
                  <i *ngIf="option.value == mainFilterItem.selected.value" class='fa fa-check'></i>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <button class="btn btn-link btn-slider-toggle ml-2 position-relative"
      *ngIf="(isFreemium || userService.ottAppSpoofingEnabled()) && insightsData?.overview?.victimOfSpoofing"
      [ngClass]="{ off: !includeAppSpoofing}" (click)="toggleAppSpoofing()">
      Include Spoofing
      <div class="d-inline-block" [ngClass]="{disabled: isFreemium}">
        <div class="circle-indicator"></div>
      </div>
      <div class="filter-dropdown-tooltip" *ngIf="showAppSpoofingTooltip">
        Upgrade Required
        <i class="fa fa-caret-down"></i>
      </div>
    </button>

  </div>
  <div mrt-insights-filters class='text-right'>
    <div class="last-update-date mb-2" [ngClass]="{ 'invisible' : loading}">Last Update as of {{lastUpdateLabel}}</div>
    <app-changelog-btn (showChangelog)="showChangelog()">
    </app-changelog-btn>
  </div>
  <div mrt-insights-header-appinfo>
    <ng-container *ngIf="device === 'roku'">Roku</ng-container>
    <ng-container *ngIf="device === 'firetv'">FireTV</ng-container>
    <ng-container *ngIf="device === 'samsung'">Samsung</ng-container>
    <ng-container *ngIf="device === 'tvos'">tvOS</ng-container>
    ,&nbsp;{{region}} Region
  </div>
  <div mrt-insights-icon>
    <ng-container *ngIf="insightsData?.overview?.icon">
      <img class="app-details-logo" [attr.src]="insightsData?.overview?.icon" alt="CTV Details Logo" />
    </ng-container>
  </div>
  <div mrt-insights-apptitle class="overflow-hidden text-overflow-ellipsis">
    <ng-container *ngIf="insightsData?.overview?.title">
      {{insightsData?.overview?.title}}
    </ng-container>
  </div>
</app-insights-header>

<div class="insight-details-main-content">
  <app-side-navigation navTitle='Connected TV Insights' [availableSections]='sideNavItems'
    [enabledSectionIds]='enabledSectionIds$ | async' [activeSection]='activeSection' [showMobile]='showMobileNav'
    (showChangelogClick)='showChangelog()' (navItemClick)='handleSideNavClick( $event )'
    (navCloseClick)='showMobileNav = false'>
  </app-side-navigation>

  <main class="right-content insight-details app-details p-0" *ngIf="desktop$ | async"
    [ngClass]="{ 'hide-overlap' : hideOverlap }">
    <div class="container-fluid main-content p-0" [ngClass]="{'loading': loading, 'loadingData': loadingData}">
      <div class="body-content" id="body-content" *ngIf="insightsData && !loadingData && !showNoDataFound">
        <div class="alert alert-danger text-center" *ngIf="!loading && !insightsData?.overview?.isExistInAppStore">
          <ng-template [ngTemplateOutlet]="appNotAvailableInUS"></ng-template>
        </div>
        <div class="container-fluid px-0">
          <div class='claim-container'>
            <div class='claim-app' (click)='gotoClaimForm()' aria-role='button'>
              Get Publisher Diagnostic Report
            </div>
          </div>
          <ng-container *ngFor="let navItem of sideNavItems">
            <div class="row detail-section" *ngIf="insightsData | showIf : navItem?.showIf : device: mainFilterItems"
              [attr.id]="navItem.key" mrt-insights-section>
              <div class="col-lg-12">
                <app-insights-section-container [appName]="getAppName()" [appId]="appId" [data]="insightsData"
                  [os]="device" [device]="device" [region]="region" [month]="month" [isFreemium]="isFreemium"
                  [isAnonymous]="isAnonymous" [selectedCountry]="selectedCountry"
                  [widgetComponent]="navItem?.widgetComponent" (toAppDiscovery)="toAppDiscoveryClick($event)"
                  (followButtonBreakpointReached)='followBreakpointReached = $event'
                  (followButtonClick)='handleFollowClick($event)' (anchorClick)="goToSection($event)">
                </app-insights-section-container>
              </div>
            </div>
          </ng-container>
        </div>
        <ng-container *ngIf='isFreemium'>
          <div class='row enterprise-bg p-3'>
            <div class='col'>
              <div class='enterprise-header text-center'>
                Get More Insights with MRT Enterprise
              </div>
            </div>
          </div>
          <div class='row p-3'>
            <div class='col'>
              <div class='feature-grid'>
                <div class='feature-cell'>
                  <div class='feature-icon'>
                    <i class='fa fa-mobile'></i>
                  </div>
                  <div class='feature-text'>
                    <div class='feature-text-head'>5M+</div>
                    <div class='feature-text-body'>mobile apps analyzed</div>
                  </div>
                </div>
                <div class='feature-cell'>
                  <div class='feature-icon'>
                    <i class='fa fa-tv'></i>
                  </div>
                  <div class='feature-text'>
                    <div class='feature-text-head'>40K+</div>
                    <div class='feature-text-body'>CTV apps analyzed<br />app categories</div>
                  </div>
                </div>
                <div class='feature-cell'>
                  <div class='feature-icon'>
                    <i class='fa fa-list-ul'></i>
                  </div>
                  <div class='feature-text'>
                    <div class='feature-text-head'>200M+</div>
                    <div class='feature-text-body'>websites analyzed</div>
                  </div>
                </div>
                <div class='feature-cell'>
                  <div class='feature-icon'>
                    <i class='fa fa-star-half-o'></i>
                  </div>
                  <div class='feature-text'>
                    <div class='feature-text-head'>500+</div>
                    <div class='feature-text-body'>metrics</div>
                  </div>
                </div>
                <div class='feature-cell'>
                  <div class='feature-icon'>
                    <i class='fa fa-sitemap'></i>
                  </div>
                  <div class='feature-text'>
                    <div class='feature-text-head'>40+</div>
                    <div class='feature-text-body'>App Categories</div>
                  </div>
                </div>
                <div class='feature-cell'>
                  <div class='feature-icon'>
                    <i class='fa fa-globe'></i>
                  </div>
                  <div class='feature-text'>
                    <div class='feature-text-head'>4</div>
                    <div class='feature-text-body'>global regions</div>
                  </div>
                </div>
              </div>
            </div>
            <div class='col'>
              <ul class='enterprise-feature-list pl-3'>
                <li>Protect your network from fraud and brand safety risks.</li>
                <li>Provide the data to understand publishers that should automatically be excluded from my network
                  based on my own risk tolerance</li>
                <li>Make certain my network is made up of publishers without compliance risks and COPPA violations</li>
                <li>Maintain a network with low security risks/data security for my advertisers</li>
                <li>Create a clean supply chain in CTV, Mobile Apps, and Websites and educate myself on CTV specific
                  risks</li>
                <li>Create allow/block lists of IVT free and brand safe CTV, Mobile Apps and websites to buy on</li>
              </ul>
              <div class='pl-3'>
                <button class='btn btn-primary btn-schedule-a-demo' (click)='_eventBus.openScheduleADemo()'>Schedule a
                  Demo!</button>
              </div>
            </div>
          </div>
          <div class='row enterprise-bg p-3'>
            <div class='col'>
              <div class="customer-logo-container">
                <div class='title-text'>Trusted By</div>
                <div class='customer-logo-list'>
                  <div class="customer-logo">
                    <img src="/assets/images/criteo.png" />
                  </div>
                  <div class="customer-logo">
                    <img src="/assets/images/linkedin.png" />
                  </div>
                  <div class="customer-logo">
                    <img src="/assets/images/pubmatic.png" />
                  </div>
                  <div class="customer-logo">
                    <img src="/assets/images/verizon.png" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
      <ng-template [ngTemplateOutlet]="noDataFoundTemplate"></ng-template>
      <div class="p-4" *ngIf="loadingData">
        Loading data
        <i class="fa fa-spin fa-spinner ml-2"></i>
      </div>
    </div>
  </main>

  <main class="w-100 mobile-main" *ngIf="tablet$ | async">
    <div class="container-fluid px-0" *ngIf="insightsData && !loadingData && !showNoDataFound">
      <div class="alert alert-danger" *ngIf="!loading && !insightsData?.overview?.isExistInAppStore">
        <ng-template [ngTemplateOutlet]="appNotAvailableInUS"></ng-template>
      </div>
      <div class="row">
        <div class="col">
          <ng-template #swipercontrols>
            <div class="swiper-controls" *ngIf="swiper?.swiperRef">
              <button class="btn btn-link p-0 mr-2" [ngClass]="{ disabled: swiper.swiperRef.isBeginning }"
                (click)="swiper.swiperRef.slidePrev(300)">
                <img src="assets/images/arrow-left.svg" />
              </button>
              <button class="btn btn-link p-0" [ngClass]="{ disabled: swiper.swiperRef.isEnd }"
                (click)="swiper.swiperRef.slideNext(300)">
                <img src="assets/images/arrow-right.svg" />
              </button>
            </div>
          </ng-template>
          <swiper #swiper [autoHeight]="true" [slidesPerView]="1" [spaceBetween]="0"
            wrapperClass="swiper-wrapper min-h-100vh" (slideChange)="onSlideChange($event)">
            <ng-container *ngFor="let navItem of sideNavItems; first as isFirst; index as index;">
              <ng-container *ngIf="insightsData | showIf : navItem?.showIf : device: mainFilterItems">
                <ng-template swiperSlide let-data>
                  <div [attr.id]="navItem.key" mrt-insights-section>
                    <ng-container *ngIf="data?.isActive || data?.isPrev || data?.isNext">
                      <app-insights-section-container class="w-100" [appName]="getAppName()" [appId]="appId"
                        [data]="insightsData" [device]="device" [region]="region" [month]="month"
                        [isFreemium]="isFreemium" [isAnonymous]="isAnonymous" [includeAppSpoofing]="includeAppSpoofing"
                        [selectedCountry]="selectedCountry" [widgetComponent]="navItem?.widgetComponent"
                        (toAppDiscovery)="toAppDiscoveryClick($event)" [swiperControls]="swipercontrols"
                        (followButtonBreakpointReached)='followBreakpointReached = $event'
                        (followButtonClick)='handleFollowClick($event)' (anchorClick)="goToSection($event)">
                      </app-insights-section-container>
                    </ng-container>
                  </div>
                </ng-template>
              </ng-container>
            </ng-container>
          </swiper>
        </div>
      </div>
    </div>
    <ng-template [ngTemplateOutlet]="noDataFoundTemplate"></ng-template>
    <ng-container *ngIf="loading || loadingData">
      <div style="margin-top: 25vh; margin-left: calc(50vw - 70px);">
        <i class="fa fa-spinner fa-spin mr-2"></i> Loading data...
      </div>
    </ng-container>
  </main>
</div>

<ng-container>
  <div class="modal fade" id="changelogModal" tabindex="-1" role="dialog" aria-labelledby="changelogModalLabel"
    aria-hidden="true" #changelogModal>
    <div class="modal-dialog modal-fullscreen" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title w-100">
            <h6 class="mb-3 d-sm-none">Changelog</h6>
            <div class="d-flex flex-row">
              <img class="appIcon" [attr.src]="insightsData?.overview?.icon"
                [attr.alt]="insightsData?.overview?.title + ' Icon'" />
              <div class="d-flex flex-column flex-md-row justify-content-between align-items-md-center mr-sm-5 w-100">
                <h5 class="d-inline">{{insightsData?.overview?.title}}</h5>
                <div class="d-inline">
                  <button [disabled]="processing" class="btn btn-primary d-flex flex-nowrap"
                    [class.btn-follow]="!isFollowing" [class.btn-unfollow]="isFollowing"
                    (click)="isFollowing ? unfollowApp() : followApp()">
                    <ng-container *ngIf="!isFreemium">
                      <i class="fa fa-check mr-1" *ngIf="isFollowing"></i>
                      <i class="fa fa-plus mr-1" *ngIf="!isFollowing"></i>
                    </ng-container>
                    <ng-container *ngIf="isFreemium">
                      <i class="fa fa-lock mr-1" *ngIf="!isFollowing"></i>
                      <i class="fa fa-check mr-1" *ngIf="isFollowing"></i>
                    </ng-container>
                    {{ isFollowing ? "Following" : "Follow" }}
                    <ng-container *ngIf="isFreemium && !isFollowing">
                      to show all changes
                    </ng-container>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <app-app-changelog [changeLogData]="changeLogData" [region]="region" [isFollowing]="isFollowing"
            [isFreemium]="isFreemium"></app-app-changelog>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #noDataFoundTemplate>
  <div class="no-data-container" *ngIf="showNoDataFound">
    <div class="alert alert-warning" role="alert">
      <strong>Not found.</strong> Sorry no {{region}} information was found for {{appId}} on {{device}} <span
        *ngIf="month">with month {{monthLabel}}</span>.
    </div>
    <div class="alert alert-warning available-filters" role="alert" *ngIf="availableFilters?.length > 0">
      Try other available searches ?
      <ul>
        <li *ngFor="let availableFilter of availableFilters">
          <a class="btn btn-link" (click)="availableFilterClick(availableFilter)">
            {{availableFilter.region}} for {{availableFilter.appid}} <ng-container *ngIf="availableFilter?.monthLabel">
              in {{availableFilter?.monthLabel}}</ng-container>
          </a>
        </li>
      </ul>
    </div>
  </div>
</ng-template>

<ng-template #appNotAvailableInUS>
  <img src="./assets/images/icon-warning.svg" width="14" alt="Warning Icon" />
  This App is no longer available in the U.S. {{device}} store
  <span
    *ngIf="!insightsData?.overview?.isExistInAppStore && insightsData?.appInfo?.appRemovedDate && insightsData?.appInfo?.appRemovedDate !== 'N/A'">
    as of {{insightsData?.appInfo?.appRemovedDate | date}}</span>.
</ng-template>